var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypanel-container"},[(_vm.title!=null)?_c('div',{staticClass:"mypanel-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"mypanel-items"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }